import { render } from "./GastouderStatusBadge.vue?vue&type=template&id=ed16ae08"
import script from "./GastouderStatusBadge.vue?vue&type=script&lang=js"
export * from "./GastouderStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__